var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{stroke:#79878c;stroke-miterlimit:10;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "My Account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.55,15.77H1.65a9.23,9.23,0,0,1,6-6.64.32.32,0,0,0,.1-.55,4.28,4.28,0,1,1,5.73,0,.36.36,0,0,0,.11.6A9.19,9.19,0,0,1,19.55,15.77Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1,
    y1: 17.72,
    x2: 20,
    y2: 17.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 21,
    height: 19
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccount);
export default __webpack_public_path__ + "static/media/My-Account.b6b7358f5415db1e00a66e5f11e27a6a.svg";
export { ForwardRef as ReactComponent };